import React, {useEffect, useState} from 'react'
import {useTranslation} from "react-i18next";
import Fade from "@mui/material/Fade";
import Card from "@mui/material/Card";

import Grid from "@mui/material/Grid";
import moment from "moment";
import {Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";
import { v4 as uuidv4 } from 'uuid';
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import {MuiDataGrid} from "../../components/MuiDatagrid";
import {UnitArray,GiftArray,QualityCodeArray} from "../../utils/globalFunction";
import {useDispatch, useSelector} from "react-redux";
import {onErrorAlert, onSuccessAlert} from "../../actions";
import Tooltip from "@mui/material/Tooltip";
import {MaterialReactTable, useMaterialReactTable} from "material-react-table";
import {MRT_Localization_EN} from "material-react-table/locales/en";
import {MRT_Localization_ZH_HANS} from "material-react-table/locales/zh-Hans";
import {checkPermission, PERMISSION_DICT} from "../../utils/Users_Roles_Permission";
import MDButton from "../../components/MDButton";
import { Tabs, Tab} from "@mui/material";
import {createTheme, ThemeProvider} from "@mui/material/styles";

const muiTheme = createTheme({
    slider: {
        trackColor: "yellow",
        selectionColor: "green"
    }
});

const InboundProductDetail = ({list = [], listActual= [],loading}) => {
    const [tabIndex, setTabIndex] = useState(0);
    const [isOpen,setIsOpen] = useState(true)
    const [rows,setRows] = useState([])
    const [rowsActual,setRowsActual] = useState([])
    const {t} = useTranslation()
    const dispatch = useDispatch()
    const handleClickCopy = (textToCopy) => {
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    dispatch(onSuccessAlert(`"${textToCopy}" ${t('copied')}`))
                })
                .catch((err) => {
                    dispatch(onErrorAlert(`${t('copy failed')}`))
                });
        }

    };

    useEffect(()=>{
        setRows([...list].map(value => {
            return {
                ...value,id:uuidv4()
            }
        }))
    },[list])

    useEffect(()=>{
        setRowsActual([...listActual].map((value,index) => {
            return {
                ...value,id:uuidv4(),index:index + 1
            }
        }))
    },[listActual])

    const handleCellCopyClick = (text) => {
        const textToCopy = text
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(textToCopy)
                .then(() => {
                    dispatch(onSuccessAlert(`"${textToCopy}" ${t('copied')}`))
                })
                .catch((err) => {
                    dispatch(onErrorAlert(`${t('copy failed')}`))
                });
        }

    };

    const [dragState, setDragState] = useState({
        isDragging: false,
        startCell: null,
        endCell: null,
    });

    const handleChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    const [isCopyOpen,setIsCopyOpen] = useState(false)

    const onCellMouseDown = (event,cell) => {

        event.stopPropagation();
        event.preventDefault();
        if (cell.column.id === 'sku') {
            setDragState({
                isDragging: true,
                startCell: cell,
                endCell: null,
            });
        }
    };

    const onCellMouseEnter = (event,cell) => {
        event.stopPropagation();
        event.preventDefault();
        if (dragState.isDragging && cell.column.id === dragState.startCell.column.id) {
            setDragState({
                ...dragState,
                endCell: cell,
            });
        }
    };

    const onCellMouseUp = (event) => {
        event.stopPropagation();  // 阻止事件冒泡
        event.preventDefault();
        let { startCell, endCell } = dragState;
        if (startCell && endCell && startCell.column.id === endCell.column.id) {
            if (startCell.row.index > endCell.row.index) {
                // 如果起始行大于结束行，交换它们
                [startCell, endCell] = [endCell, startCell];
            }

        }

        // 更新状态，结束拖拽
        setDragState({
            isDragging: false,
            startCell,
            endCell
        });
    };


    useEffect(() => {

        if(!dragState.isDragging && dragState.startCell && dragState.endCell){
            setIsCopyOpen(true)
        }
    }, [dragState]);


    const columns = [
            {
                accessorKey: 'applyAsnLineNo',
                header: t('No.'),
                size: 20,
                muiTableBodyCellProps: ({ cell }) => ({
                    onDoubleClick: (event) => {
                        handleCellCopyClick(cell.getValue())
                    },
                }),

            },
        {
            accessorKey: 'sku',
            header: t('ProductPage.Product SKU'),
            size: 150,
            muiTableBodyCellProps: ({row, cell}) => {

                let dataTutAttr = {};
                // 判断 data.length 是否大于等于 5，如果是，才添加 `data-tut` 属性
                if (rows.length >= 2) {
                    if (row.index === 0) {
                        dataTutAttr = {'data-tut': 'reactour_start'};
                    } else if (row.index === 1) {
                        dataTutAttr = {'data-tut': 'reactour_end'};
                    }
                }
                const additionalClassName = row.index >= 0 && row.index <= 2 ? 'reactour_range' : '';

                return {
                    ...dataTutAttr,
                    className: additionalClassName,
                    sx: {
                        borderColor: (cell.column.id === 'sku' &&
                            cell.row.index >= (dragState.startCell ? dragState.startCell.row.index : -1) &&
                            cell.row.index <= (dragState.endCell ? dragState.endCell.row.index : -1)) ? {
                            borderColor: '#FFA726 !important',
                        } : {},
                        height: '30px',
                    },
                    onDoubleClick: (event) => {
                        handleCellCopyClick(cell.getValue())
                    },
                    onMouseDown: (event) => onCellMouseDown(event, cell),
                    onMouseEnter: (event) => onCellMouseEnter(event, cell),
                    onMouseUp: (event) => onCellMouseUp(event),
                }

            }
        },
        {
            accessorKey: 'skuAlias',
            header: t('SKU Alias'),
            size: 100,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),

        },
        {
            accessorKey: 'productName',
            header: t('ProductPage.productName'),
            size: 250,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),

        },
        {
            accessorKey: 'unit',
            header: t('ProductPage.Unit'),
            type: 'singleSelect',
            editable: false,
            valueOptions: UnitArray,
            getOptionValue: (value) => value?.value,
            getOptionLabel: (value) => `${value?.label}`,
            size: 60

        },
        {
            accessorKey: 'unitConvertRate',
            header: t('ProductPage.Unit Rate'),
            width: 60,
            headerAlign: "left",
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },
        {
            accessorKey: 'unitQty',
            type: 'number',
            header: t('ProductPage.Unit Qty'),
            size: 65,
            headerAlign: "left",
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },

        {
            accessorKey: "price",
            header: t('InboundPage.Price'),
            type: "number",
            size: 60,
            align: "center",
            headerAlign: "left",
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },

        {
            accessorKey: "detailTotalPrice",
            header: t("InboundPage.Total Price"),
            size: 100,
            align: "center",
            headerAlign: "left",
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },
        {
            accessorKey: "qtyExpected",
            header: t('InboundPage.Expected Qty (EA)'),
            type: "number",
            size: 120,
            align: "center",
            headerAlign: "left",
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },
        {
            accessorKey: "qtyReceipt",
            header: t("InboundPage.Receipt Qty (EA)"),
            type: "number",
            size: 120,
            align: "center",
            headerAlign: "left",
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },


        // {
        //     field: 'isGift',
        //     headerName: 'Complimentary Gift',
        //     type: 'singleSelect',
        //     valueOptions: GiftArray,
        //     getOptionValue: (value) => value?.value,
        //     getOptionLabel: (value) => `${value?.label}`,
        //     width: 170
        //
        // },
        //
        // {
        //     field: 'qualityCode',
        //     headerName: 'Quality Status',
        //     type: 'singleSelect',
        //     valueOptions: QualityCodeArray,
        //     getOptionValue: (value) => value?.value,
        //     getOptionLabel: (value) => `${value?.label}`,
        //     width: 200
        //
        // },

        {
            accessorKey: 'batchNo',
            header: t('InboundPage.Batch No.'),
            size: 100,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
        },
        {
            accessorKey: 'expirationDate',
            header: t('InboundPage.Expiration Date'),
            type: 'number',
            headerAlign: "center",
            align: "center",
            size: 150,
            Cell: ({ cell }) => (
                <span>{cell.getValue()?moment(cell.getValue()).format('YYYY-MM-DD'):''}</span>
            )


        },
        {
            accessorKey: 'warehousingDate',
            header: t('InboundPage.Warehousing Date'),
            type: 'number',
            headerAlign: "center",
            align: "center",
            size: 150,
            Cell: ({ cell }) => (
                <span>{cell.getValue()?moment(cell.getValue()).format('YYYY-MM-DD'):''}</span>
            )
        },

]
    const columnsActual = [
        {
            accessorKey: 'id',
            header: t('No.'),
            size: 30,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
            Cell: ({ cell, row }) => (
                <div>
                    {row.original.index}
                </div>
            )

        },

        {
            accessorKey: 'sku',
            header: t('ProductPage.Product SKU'),
            size: 150,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),

        },
        {
            accessorKey: 'skuDescr',
            header: t('InboundPage.Sku Description'),
            size: 150,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),

        },
        {
            accessorKey: 'qty',
            header: t('InboundPage.Received Qty'),
            size: 100,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),

        },
        // {
        //     accessorKey: 'qtyEachSigned',
        //     header: t('InboundPage.Qty Each Signed'),
        //     size: 150,
        //     muiTableBodyCellProps: ({ cell }) => ({
        //         onDoubleClick: (event) => {
        //             handleCellCopyClick(cell.getValue())
        //         },
        //     }),
        //
        // },
        //
        // {
        //     accessorKey: "price",
        //     header: t('InboundPage.Price'),
        //     type: "number",
        //     size: 80,
        //     align: "center",
        //     headerAlign: "left",
        //     muiTableBodyCellProps: ({ cell }) => ({
        //         onDoubleClick: (event) => {
        //             handleCellCopyClick(cell.getValue())
        //         },
        //     }),
        // },
        // {
        //     accessorKey: 'detailTotalPrice',
        //     header: t('InboundPage.Detail Total Price'),
        //     size: 150,
        //     muiTableBodyCellProps: ({ cell }) => ({
        //         onDoubleClick: (event) => {
        //             handleCellCopyClick(cell.getValue())
        //         },
        //     }),
        //
        // },
        {
            accessorKey: 'docLineNo',
            header: t('InboundPage.Doc Line No.'),
            size: 120,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),

        },
        {
            accessorKey: 'transactionTime',
            header: t('InboundPage.Transaction Time'),
            size: 150,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
            Cell: ({ cell }) => (
                <div>
                    {cell.getValue()?moment(cell.getValue()).format('YYYY-MM-DD HH:mm:ss').toString():''}
                </div>
            )

        },
        {
            accessorKey: 'batchNo',
            header: t('InboundPage.Batch No.'),
            size: 120,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),

        },
        {
            accessorKey: 'expirationDate',
            header: t('InboundPage.Expiration Date'),
            type: 'number',
            headerAlign: "center",
            align: "center",
            size: 150,
            Cell: ({ cell }) => (
                <span>{cell.getValue()?moment(cell.getValue()).format('YYYY-MM-DD'):''}</span>
            )
        },
        {
            accessorKey: 'warehousingDate',
            header: t('InboundPage.Warehousing Date'),
            type: 'number',
            headerAlign: "center",
            align: "center",
            size: 150,
            Cell: ({ cell }) => (
                <span>{cell.getValue()?moment(cell.getValue()).format('YYYY-MM-DD'):''}</span>
            )
        },
        {
            accessorKey: 'qualityStatus',
            header: t('InboundPage.qualityStatus'),
            size: 120,
            muiTableBodyCellProps: ({ cell }) => ({
                onDoubleClick: (event) => {
                    handleCellCopyClick(cell.getValue())
                },
            }),
            Cell: ({ cell }) => {
                const cellValue = cell.getValue();
                const found = QualityCodeArray.find(option => option.value === cellValue);
                return <span>{found ? found.label : cellValue}</span>;
            },

        },
    ]
    const languageSelect = useSelector(state => state?.common?.language,(prev, next) => prev === next)
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 50, //customize the default page size
    });

    const [paginationActual, setPaginationActual] = useState({
        pageIndex: 0,
        pageSize: 50, //customize the default page size
    });

    const table = useMaterialReactTable({
        enableColumnActions: false,
        columns,
        data: rows,
        enableSorting: false,
        enableColumnPinning: false,
        enableColumnFilters: false,
        enableToolbarInternalActions: false,
        enableFullScreenToggle: false,
        enableGlobalFilter: false,
        enableBottomToolbar: false,
        getRowId: (row) => (row.id),
        enableRowSelection: false,
        enableRowActions: false,
        displayColumnDefOptions: {
            'mrt-row-actions': {
                size: 60, //if using layoutMode that is not 'semantic', the columns will not auto-size, so you need to set the size manually
                grow: false,
            },
        },
        positionActionsColumn: 'last',
        enableRowNumbers: false,
        rowNumberDisplayMode: 'static',
        rowCount:rows.length,
        paginationDisplayMode: 'pages',
        positionToolbarAlertBanner: 'bottom',
        enableColumnResizing: true,

        enableStickyHeader: true,
        enableStickyFooter: true,
        manualPagination: true,
        enableDensityToggle: false,
        enableBatchRowSelection: false,
        localization:languageSelect === 'en'?MRT_Localization_EN:MRT_Localization_ZH_HANS,
        initialState: {
            density: 'compact',
            columnVisibility: {
                ownerId:checkPermission(PERMISSION_DICT.QueryOwnerInfo),
                ownerName: checkPermission(PERMISSION_DICT.QueryOwnerInfo),
                totalVolume:false,
                totalPrice:false,
                totalWeight:false,
                lockStatus:false,
                orderDueDate:false,
                lockType:false,
                wmsShipMode:false,
                invState:false,
                signState:false,
                processState:false,
                executeState:false,
                businessType:false,
                hangStatus:false,
                expectedShipmentTime:false,
                requiredDeliveryTime:false,
                consigneeId:false,
                consigneeName:false,
                consigneeContact:false,
                consigneeTel1:false
            },
        },
        onPaginationChange:setPagination,
        state: {
            pagination,
            isLoading:loading,
            showLoadingOverlay:false,
            showSkeletons:loading,
            showAlertBanner:false,
        },
        muiPaginationProps: {
            rowsPerPageOptions: [50, 100, 200],
            showFirstButton: true,
            showLastButton: true,
            color: 'primary',
            shape: 'rounded',
            showRowsPerPage: true,
            size:'small',
        },
        muiTableBodyCellProps:({ table }) => ({

            sx: (theme) => ({
                height:'30px',
            }),
            onClick: (event) => { event.preventDefault();}
        }),
        muiTableContainerProps: ({ table }) => ({
            sx: {

                maxHeight: table.getState().isFullScreen ?  undefined:640,
            },
        }),
        renderTopToolbarCustomActions: null,
        muiTopToolbarProps:{
            sx: (theme) => ({
                maxWidth:'100%',
                background: theme.palette.background.table,
                // padding:'20px',
                '& > div': {
                    padding: '0px',
                },
                '& > div:nth-of-type(2)': {
                    display:'flex',
                    flexWrap:'wrap'
                },
            }),
        },
        muiBottomToolbarProps:{sx: (theme) => ({backgroundColor:`${theme.palette.background.card} !important`})},
        muiTablePaperProps:{sx:
                {
                    boxShadow:'none',
                    '& > div:nth-of-type(1)': {
                        minHeight: '0', // 或者 'auto'
                    },
                }
        },
        muiSearchTextFieldProps:{
            placeholder: 'Search current page...',
        }



    });

    const tableActual = useMaterialReactTable({
        enableColumnActions: false,
        columns:columnsActual,
        data: rowsActual,
        enableSorting: false,
        enableColumnPinning: false,
        enableColumnFilters: false,
        enableToolbarInternalActions: false,
        enableFullScreenToggle: false,
        enableGlobalFilter: false,
        enableBottomToolbar: false,
        getRowId: (row) => (row.id),
        enableRowSelection: false,
        enableRowActions: false,
        displayColumnDefOptions: {
            'mrt-row-actions': {
                size: 60, //if using layoutMode that is not 'semantic', the columns will not auto-size, so you need to set the size manually
                grow: false,
            },
        },
        positionActionsColumn: 'last',
        enableRowNumbers: false,
        rowNumberDisplayMode: 'static',
        rowCount:rowsActual.length,
        paginationDisplayMode: 'pages',
        positionToolbarAlertBanner: 'bottom',
        enableColumnResizing: true,

        enableStickyHeader: true,
        enableStickyFooter: true,
        manualPagination: true,
        enableDensityToggle: false,
        enableBatchRowSelection: false,
        localization:languageSelect === 'en'?MRT_Localization_EN:MRT_Localization_ZH_HANS,
        initialState: {
            density: 'compact',
            columnVisibility: {
                ownerId:checkPermission(PERMISSION_DICT.QueryOwnerInfo),
                ownerName: checkPermission(PERMISSION_DICT.QueryOwnerInfo),
                totalVolume:false,
                totalPrice:false,
                totalWeight:false,
                lockStatus:false,
                orderDueDate:false,
                lockType:false,
                wmsShipMode:false,
                invState:false,
                signState:false,
                processState:false,
                executeState:false,
                businessType:false,
                hangStatus:false,
                expectedShipmentTime:false,
                requiredDeliveryTime:false,
                consigneeId:false,
                consigneeName:false,
                consigneeContact:false,
                consigneeTel1:false
            },
        },
        onPaginationChange:setPaginationActual,
        state: {
            paginationActual,
            isLoading:loading,
            showLoadingOverlay:false,
            showSkeletons:loading,
            showAlertBanner:false,
        },
        muiPaginationProps: {
            rowsPerPageOptions: [50, 100, 200],
            showFirstButton: true,
            showLastButton: true,
            color: 'primary',
            shape: 'rounded',
            showRowsPerPage: true,
            size:'small',
        },
        muiTableBodyCellProps:({ table }) => ({

            sx: (theme) => ({
                height:'30px',
            }),
            onClick: (event) => { event.preventDefault();}
        }),
        muiTableContainerProps: ({ table }) => ({
            sx: {

                maxHeight: table.getState().isFullScreen ?  undefined:640,
            },
        }),
        renderTopToolbarCustomActions: null,
        muiTopToolbarProps:{
            sx: (theme) => ({
                maxWidth:'100%',
                background: theme.palette.background.table,
                // padding:'20px',
                '& > div': {
                    padding: '0px',
                },
                '& > div:nth-of-type(2)': {
                    display:'flex',
                    flexWrap:'wrap'
                },
            }),
        },
        muiBottomToolbarProps:{sx: (theme) => ({backgroundColor:`${theme.palette.background.card} !important`})},
        muiTablePaperProps:{sx:
                {
                    boxShadow:'none',
                    '& > div:nth-of-type(1)': {
                        minHeight: '0', // 或者 'auto'
                    },
                }
        },
        muiSearchTextFieldProps:{
            placeholder: 'Search current page...',
        }



    });

    return(<React.Fragment>
            <Fade in = {true}>
                <Card sx={{minWidth: 250}}>
                    <MDBox
                        mx={1}
                        mt={-3}
                        py={1}
                        px={2}
                        variant="gradient"
                        bgColor="light"
                        borderRadius="lg"
                        coloredShadow="light"
                        display={'flex'}
                        alignItems={'center'}
                        justifyContent={'space-between'}

                    >
                        <MDTypography variant="h6" fontWeight="medium">
                            {t('Products Information')}
                        </MDTypography>
                        <IconButton size={'small'} disabled={loading} onClick={()=>setIsOpen(!isOpen)}>
                            {(isOpen && !loading)?<Icon>expand_less</Icon>:<Icon>expand_more</Icon>}
                        </IconButton>
                    </MDBox>
                    <Collapse in={isOpen&& !loading} timeout={500}>
                        <MDBox  pb={2} mt={1} px={2}>
                            <MDBox sx={{width:"50%"}}>
                                <ThemeProvider theme={muiTheme}>
                                    <Tabs value={tabIndex} onChange={handleChange} aria-label="table tabs"
                                          sx={{
                                              minHeight: 32,
                                              ".MuiTabs-flexContainer": {
                                                  gap: 1,
                                              },
                                              ".MuiTabs-indicator": {
                                                  backgroundColor: "#1976d2",
                                                  height: 2,
                                                  borderRadius: 1,
                                              },
                                          }}
                                    >
                                        <Tab label={t("InboundPage.Order Details")}
                                             sx={{
                                                 minHeight: 32,
                                                 minWidth: 100,
                                                 px: 2,
                                                 py: 0.5,
                                                 fontSize: "0.875rem",
                                                 textTransform: "none",
                                                 fontWeight: 500,
                                                 color: "#666",
                                                 "&.Mui-selected": {
                                                     color: "#1976d2",
                                                 },
                                             }}/>
                                        <Tab label={t("InboundPage.Actual Inbound Details")}
                                             sx={{
                                                 minHeight: 32,
                                                 minWidth: 140,
                                                 px: 2,
                                                 py: 0.5,
                                                 fontSize: "0.875rem",
                                                 textTransform: "none",
                                                 fontWeight: 500,
                                                 color: "#666",
                                                 "&.Mui-selected": {
                                                     color: "#1976d2",
                                                 },
                                             }}
                                        />
                                    </Tabs>
                                </ThemeProvider>
                            </MDBox>
                            {tabIndex === 0 && (
                                <Grid sx={{ width: "100%", mt: 2 }}>
                                    <MaterialReactTable table={table} />
                                </Grid>
                            )}

                            {tabIndex === 1 && (
                                <MDBox sx={{ mt: 2 }}>
                                    {/* 这里你可以以后加上第二个表格 */}
                                    <MaterialReactTable table={tableActual} />
                                </MDBox>
                            )}
                        </MDBox >
                    </Collapse>

                </Card>
            </Fade>
            <Dialog
                open={isCopyOpen}
                onClose={() => setIsCopyOpen(false)}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth
                maxWidth={'sm'}
                style={{ display: (isCopyOpen ? 'block' : 'none') }}

            >
                <DialogTitle id="alert-dialog-title">
                    <div>{t("Are you sure?")}</div>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {dragState.endCell?.row?.index - dragState.startCell?.row?.index <= 200 ?
                            `${t('ProductPage.Do you want to copy')} ${dragState.endCell?.row?.index - dragState.startCell?.row?.index + 1} ${t('ProductPage.SKUs to the clipboard?')}` :
                            t('You cannot copy more than 200 SKUs at a time')
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <MDButton onClick={() => {
                        setIsCopyOpen(false)
                        setDragState({
                            isDragging: false,
                            startCell: null,
                            endCell: null,
                        })
                    }}>
                        {t('Cancel')}
                    </MDButton>

                    <MDButton
                        disabled={dragState.endCell?.row?.index - dragState.startCell?.row?.index > 200}
                        color={'primary'}
                        variant={'contained'}
                        data-tut="reactour_step3"
                        onClick={() => {
                            // if(currentStep !== 0) return
                            const startRowIndex = Math.min(dragState.startCell.row.index, dragState.endCell.row.index);
                            const endRowIndex = Math.max(dragState.startCell.row.index, dragState.endCell.row.index);


                            const kitSkuData = rows.slice(startRowIndex, endRowIndex + 1)
                                .map(row => row['sku'])  // 假设'kitSku'是数据对象中对应列的键
                                .join('\n');  // 使用换行符分隔，以便在复制到Excel等表格应用时形成单列


                            // 复制到剪切板
                            navigator.clipboard.writeText(kitSkuData)
                                .then(() => dispatch(onSuccessAlert(`${t('ProductPage.Sku data copied to clipboard')}`)))
                                .catch(err => dispatch(onErrorAlert((`${t('Failed to copy data')}: ${err}`))));
                            setIsCopyOpen(false)
                            setDragState({
                                isDragging: false,
                                startCell: null,
                                endCell: null,
                            })
                        }}>
                        {t('YES')}
                    </MDButton>
                </DialogActions>
            </Dialog>

        </React.Fragment>
    )
}

export default InboundProductDetail